<template>
  <app-base-main
      :hasMagin="false"
      no-padding
      parentTable
      table-border-top
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          :isBr="false"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" @change="campaignSelectChange($event)" width="180px"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SP"></ad-group-select>
        <gj-select
            v-model="filter.status"
            :options="AdKeywordEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="filter.matchType"
            :options="AdKeywordEnum.SP.matchTypeOption"
            placeholder="匹配类型"
        ></gj-select>
        <gj-select
            v-model="filter.strategyStatus"
            :options="AdStrategyStatusEnum.option"
            placeholder="分时策略"
        ></gj-select>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 0, text: '模糊查询'},
              {id: 1, text: '精准查询'},
            ]"
        ></gj-select-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/keywords/export" :download-params="globalParams"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add"
      >新增关键词</gj-button>
      <gj-button :disabled="!selectedAllIsNot('state', AdKeywordEnum.SP.status.ARCHIVE)" @click="adjustBidAddPopup"> 应用建议竞价 </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdKeywordEnum.SP.status.ARCHIVE)"
          @click="adjustBid">
        调整竞价
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdKeywordEnum.SP.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdKeywordEnum.SP.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdKeywordEnum.SP.status.ENABLE, AdKeywordEnum.SP.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/keywords/export" :download-params="globalParams"
      >
      <template #before>
        <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
      </template></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :show-overflow="false"
          :pagination="pagination"
          show-summary :summary-object="sumRecord"
          :show-header-overflow="true"
          :show-footer-overflow="true"
          :scroll-y="{mode: 'wheel', oSize:10, gt: 40 }"
          :selectable="notEqSelectable('state', AdKeywordEnum.SP.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSpCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdKeywordEnum.SP.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdKeywordEnum.SP.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdKeywordEnum.SP.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:keywordText="{row}">
          <gj-tooltip :content="row.keywordText" :text-line="1"><gj-link :href="row.amazonUrl" target="_blank">{{row.keywordText | defaultShow}}</gj-link></gj-tooltip>
          <gj-tooltip :content="row.localizeKeywordText" :text-line="1"><div v-if="row.localizeKeywordText">{{row.localizeKeywordText | defaultShow}}</div></gj-tooltip>
        </template>
        <template v-slot:belongGroup="{row}">
          <app-sp-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
<!--        <template v-slot:bid="{row}">-->
<!--          {{row.bid | defaultShow(row.currencySymbol)}}-->
<!--        </template>-->
        <template v-slot:bid="{ row }">
          <gj-tooltip :text-line="1">
            <template #content>{{ row.bid | amount | defaultShow(row.currencySymbol) }}</template>
            {{ row.bid | amount | defaultShow(row.currencySymbol) }}
          </gj-tooltip>
          <AdEditBid
            :value="row"
            :isEdit="row.state !== AdKeywordEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')"
            :currencySymbol="row.currencySymbol"
            :updateValue="updateBid">
          </AdEditBid>
        </template>
        <!-- 建议竞价 -->
        <template v-slot:suggestBid="{ row }">
          <div class="bid-refresh" style="color: #0046f0;">
              <i class="el-icon-refresh" v-if="!row.refresh" @click="bidRefresh(row)" style="cursor: pointer;"></i>
              <i class="el-icon-loading" v-else-if="row.refresh == 1"></i>
              <div v-else-if="row.refresh == 2">
                <div>{{ row.recommended  | defaultShow(row.currencySymbol)}}</div>
                <div style="color: #333">
                  {{ row.rangeStart | defaultShow(row.currencySymbol)}} ~ 
                  {{ row.rangeEnd | defaultShow(row.currencySymbol)}}
                </div>
              </div>
              <div style="color: #999;" v-else-if="row.refresh == 3">暂无建议</div>
          </div>
        </template>
        <template v-slot:strategyStatus="{ row }">
        {{AdStrategyStatusEnum.option[row.strategyStatus].text || row.strategyStatus}}
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 0 || row.strategyStatus === 1">
            <gj-tooltip content="编辑">
              <i class="el-icon-edit color999" @click="timeAdjust(row)"></i>
            </gj-tooltip>
            <gj-tooltip content="移除">
              <i class="iconfont iconshanchu size13 color999" style="margin-left: 10px;" @click="deleteEvent(row)"></i>
            </gj-tooltip>
          </div>
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 2">
                <gj-button type="text" @click="timeAdjust(row)" >去添加</gj-button>
          </div>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              v-if="row.state === AdKeywordEnum.SP.status.ARCHIVE || !$permission('adsStrategyObject:add')"
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
          <gj-button-group v-else type="dropdown-op">
            <gj-button type="text" v-if="false" @click="viewAdjustLog(row)">调价日志</gj-button>
              <gj-button type="text" @click="viewLog(row)">操作日志</gj-button>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin, adAdvancedFilteringMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin, resizeMixin,
    tableNameMixin,
    adKeywordTranslation
  } from "../../../common/mixin";
  import {AdKeywordEnum, AdStrategyStatusEnum, AdLog} from "../../../common/enum";
  import {queryMixin, responseMixin, selectionMixin} from "@/minxins";
  import AppAdjustBidModal from "../../../common/modal/adjust/adjust-bid-modal";
  import AppAddSpAdKeyword from "../../common/modal/add/keyword/add-ad-keyword";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";
  import {subDays} from 'date-fns';
  import {adStore} from "../../../common/store";
  import {
    addAdsAdjustStrategy,
    updateAdsAdjustStrategyObject,
    getSpAdKeywordPage,
    updateSpAdKeyword,
    updateSpAdKeywordNew,
    getBidRecommendationsWithTargets,
    SP,
    batchUpdateStrategyObject,
    deleteAdsAdjustStrategyTpl,
  } from "@/api/ad";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";
  import {LOG_OP_TYPE} from "../../../common/options";
  import AppAdTimeAdjustStrategyOpModal
    from "../../../strategy/time-adjust/modal/strategy-op/time-adjust-strategy-op-modal";
  import {OpEnum} from "@/utils/options";
  import {AdStrategyEnum} from "../../../strategy/common/enum";
  import AppStrategyAdjustLogModal from "./modal/strategy-adjust-log-modal";
  import AdEditBid from "modules/ad/common/components/ad-edit-bid.vue";
  import {getResumeConditionInfo, deleteStrategy} from '../../const'
  export default {
    name: "app-sp-ad-keyword",
    components: {AppSpAdRouteLink, AdCampaignSelect, AdGroupSelect, AdEditBid},
    mixins: [
      inMarketMixin, inPortfolioMixin, resizeMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin, responseMixin,
      queryMixin, currencySymbolMixin, adDefaultSortMixin, initDateMixin, adAdvancedFilteringMixin,
      adKeywordTranslation
    ],
    created() {
      this.columns = [
        adFields.status,
        adFields.keywordName,
        // {...adFields.servingStatus, options: AdKeywordEnum.SP.servingStatusOption},
        {...adFields.matchType, options: AdKeywordEnum.SP.matchTypeOption},
        {...adFields.strategyStatus, field: 'slot:strategyStatus', options: AdStrategyStatusEnum.option},
        // {...adFields.effectiveness, options: AdKeywordEnum.SP.effectivenessTypeOption},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        adFields.suggestBid,
        {...adFields.bid, field: 'slot:bid'},
        adFields.originalBid,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        adFields.acos,
        adFields.roas,
        {...adFields.op, width: '110px'},
      ].filter(e => e !== null);
    },
    inject: [ 'getCornerMark' ],
    data() {
      return {
        helpName:'spadmanager',
        lastUpdatedDate: "",
        countryName: '',
        sumRecord: {},
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        suggestedBidLoadings: [],
        AdKeywordEnum: AdKeywordEnum,
        AdStrategyStatusEnum: AdStrategyStatusEnum,
        // filter
        filter: {
          timeStamp:null,
          status: AdKeywordEnum.SP.statusNew.ENABLE_PAUSE,
          matchType: null,
          strategyStatus: null,
          keyword: {
            key: 0,
            value: null
          },
          extendSearch: null,
          date: [subDays(new Date(), 6), new Date()],
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-keyword',
        notStorage: true
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.filter.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    methods: {
      // 关键词修改
      async keywordsEdit(param) {
        const params = {
          marketId: this.marketId,
          params: param
        }
        try {
          const { data, msg, isError} = await SP.keywordsEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          data && data.forEach(item => {
            let element = this.tableData.find(e => e.keywordId === item.keywordId);
            Object.assign(element, item);
          });
        } catch (error) {
          //
        }
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          filter: {
            timeStamp: this.$route.query.timeStamp,
            status: AdKeywordEnum.SP.statusNew.ENABLE_PAUSE,
            type: null,
            keyword: {
              key: 0,
              value: this.$route.query.keyword||null
            },
            extendSearch: null,
            strategyStatus: null,
            date: this.initDate || [subDays(new Date(), 6), new Date()]
          },
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      async getTablePage() {
        this.loading = true;
        // 处理广告活动 & 广告组
        let campaignIds = this.campaignIds || [];
        let groupIds = this.groupIds || [];
        this.campaignId && (campaignIds = [ this.campaignId ]);
        this.groupId && (groupIds = [ this.groupId ]);
        // 构造查询参数
        const params = {
          model: {
            campaignIds,
            groupIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            extendSearch: this.filter.extendSearch,
            states: this.filter.status ? JSON.parse(this.filter.status) : null,
            strategyStatus: defaultVal(this.filter.strategyStatus, null),
            matchType: defaultVal(this.filter.matchType, null),
            searchType: defaultVal(this.filter.keyword.key, null),
            keywordText: defaultVal(this.filter.keyword.value, null),
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        try {
          let { data } = await SP.keywordsPage(params);
          this.sumRecord = data.sumRecord;
          this.lastUpdatedDate = data.lastUpdatedDate;
          this.countryName = data.countryName;
          this.tableData = this.currencySymbolMixin(data.records, adStore.SP.currencySymbol);
          this.tableData = this.tableData.map(e => ({
            ...e,
            refresh: null,
            rangeEnd: null,
            rangeStart: null,
            recommended: null,
          }))
          // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
          // 需从混入或者prop中获取 marketId
          this.pagination = this.getPagination(data);
          this.loading = false; // 先结束 loading，展示数据
          if(this.tableData.length>0){
            await this.getKeywordsInterpret(this.tableData)
          }
          this.setSuggestedBid(this.tableData);
        } catch (error) {
          //
        } finally {
          this.loading = false;
        }
      },
      // 更新竞价
      async updateBid(val, row) {
        const params = [{
          keywordId: row.keywordId,
          adjustmentType: 0,
          adjustmentValue: val
        }]
        await this.keywordsEdit(params);
      },
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SP', afferent)
      },
      // 竞价刷新
      async bidRefresh(row) {
        let tableData = this.tableData.filter(e => e.groupId == row.groupId)
        let keywords = tableData.map(e => ({
            keyword: e.keywordText,  matchType: e.matchType.toString()
          }))
        tableData.forEach(e => {
          this.$set(e, "refresh", 1)
        });
        let params = {
          marketId: this.marketId,
          keywordsParam: {
            keywords,
            adGroupId: row.groupId,
          }
        }
        try {
          let { data } = await getBidRecommendationsWithTargets(params)
          tableData.forEach(e => {
            let item = data.recommendations.find(j => j.keyword == e.keywordText)
            if (item) {
              if (item.suggestedBid) {
                this.$set(e, "refresh", 2)
                this.$set(e, "rangeEnd", item.suggestedBid.rangeEnd)
                this.$set(e, "rangeStart", item.suggestedBid.rangeStart)
                this.$set(e, "recommended", item.suggestedBid.suggested)
              }else {
                this.$set(e, "refresh", 3)
              }
            }
          })
        } catch (error) {
          console.log(error);
          tableData.forEach(e => {
            this.$set(e, "refresh", null)
          })
        }
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      setSuggestedBid(keywords) {
        const eachRequestNum = 80;
        for (let i = 0, j = eachRequestNum, k = 0; i < keywords.length; i += eachRequestNum, j += eachRequestNum, k++) {
          let subKeywords = keywords.slice(i, j);
          let params = {
            marketId: this.marketId,
            keywordsParam: {
              adGroupId: this.groupId,
              keywords: subKeywords.map(keyword => ({
                keyword: keyword.keywordText,
                matchType: keyword.matchType,
              }))
            }
          };
          this.suggestedBidLoadings[k] = true;
          // this.adsService.getKeywordBidRecommendations(params).pipe(
          //   finalize(() => this.suggestedBidLoadings[k] = false),
          // ).subscribe((keywordsBidRecommendations: KeywordsBidRecommendations) => {
          //   this.matchSuggestBid(subKeywords, keywordsBidRecommendations);
          // });
        }
      },
      add() {
        this.$gjCreate(AppAddSpAdKeyword, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      // 设置建议竞价弹窗
      adjustBidAddPopup() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `请确认将选择的<span style="color: red;font-weight: bold;">${this.selectedRows.length}</span>个关键词竞价调整到建议竞价，更改时只对有建议竞价的对象进行操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              this.adjustBidQuick()
              modal.$gjDestroy()
            }
          }
        });
      },
      // 设置建议竞价
      adjustBidQuick() {
        // 判断是否包含未获取建议竞价的项
        let condition = false
        for (const e of this.selectedRows) {
          if (!e.recommended) {
            condition = true
          } 
        }
        if (condition) {
          this.$gjMessage.error('请先获取建议竞价')
          let groupIds = this.selectedRows.reduce((arr, current) => {
            if (!arr.includes(current.groupId)) {
              arr.push(current.groupId)
            }
            return arr
          }, [])
          for (const e of groupIds) {
            this.bidRefresh({groupId: e})
          }
          return false
        }
        this.loading = true
        SP.keywordsEdit({
          marketId: this.marketId,
          params: this.selectedRows.map(e => ({
            campaignId: e.campaignId,
            keywordId: e.keywordId,
            adjustmentType: 0,
            adjustmentValue: e.recommended
          })),
        })
          .then(({ msg, isError }) => {
            this.$gjMessage[isError ? 'error' : 'success'](msg);
            this.$gjResetPage();
          })
          .complete(() => this.loading = false);
      },
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SP.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                keywordId: e.keywordId,
                adjustmentType: modal.form.bid.key,
                adjustmentValue: modal.form.bid.value,
              }))
              try {
                await this.keywordsEdit(params);
                modal.$gjDestroy()
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个关键词，确认启用？` : `确认启用关键词[${rows[0].keywordText}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                keywordId: e.keywordId,
                state: AdKeywordEnum.SP.status.ENABLE
              }))
              try {
                await this.keywordsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个关键词，确认停用？` : `确认停用关键词[${rows[0].keywordText}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                keywordId: e.keywordId,
                state: AdKeywordEnum.SP.status.PAUSE
              }))
              try {
                await this.keywordsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                keywordId: e.keywordId,
                state: AdKeywordEnum.SP.status.ARCHIVE
              }))
              try {
                await this.keywordsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      viewLog(row) {
        let campaignId = this.campaignId || row?.campaignId;
        let groupId = this.groupId || row?.groupId;
        let objectName = row?.keywordText;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            groupId,
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.keyWord,
            name: isMeaningful(row) ? row.keywordText : '',
          }
        });
        // this.$gjCreate(AppAdLogModal, {
        //   props: {
        //     marketId: this.marketId,
        //     campaignId: this.campaignId,
        //     groupId: this.groupId,
        //     name: isMeaningful(row) ? row.keywordText : '',
        //     opId: isMeaningful(row) ? row.keywordId : null,
        //     adType: LOG_OP_TYPE.SP,
        //     object: LOG_OP_TYPE.SP.KEYWORD
        //   }
        // });
      },
      // 广告策略
      timeAdjust(row) {
        const modal = this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            title: `<span>分时策略</span><span class="modal-secondary-title">(${row.keywordText})</span>`,
            opType: OpEnum.type.USE,
            item: row,
            objectId: row.objectId,
            strategyType: 1,// 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
          },
          on: {
            updated: () => {
              this.$gjMessage.success('操作成功');
              this.$gjResetPage();
              modal.$gjDestroy();
            },
            useStrategy: ({params, status, templateId, callback, resumeDTO}) => {
              modal.confirmLoading = true;
              let useParams;
              Promise.resolve(row.strategyStatus)
                      .then((strategyStatus) => {
                        if (strategyStatus === AdStrategyStatusEnum.NO_ADD) {
                          useParams = {
                            resumeDTO,
                            id: row.objectId,
                            adsStrategyTemplate: params,
                            marketId: row.marketId,
                            bid: row.bid,
                            status,
                            templateId,
                            campaignId: row.campaignId,
                            campaignName: row.campaignName,
                            groupId: row.groupId,
                            groupName: row.groupName,
                            objectId: row.keywordId,
                            objectName: row.keywordText,
                            objectType: AdStrategyEnum.objectType.KEYWORD
                          }
                          return addAdsAdjustStrategy(useParams)
                        } else {
                          useParams = [{
                            ...params,
                            marketId: row.marketId,
                            objectPid: row.objectId,
                            objectStatus: status,
                            templatePId:templateId,
                          }]
                          return batchUpdateStrategyObject(useParams)
                        }
                      })
                      .then((res) => {
                        if (callback) {
                          callback(res);
                        }
                      })
                .complete(() => modal.confirmLoading = false);
            },
            viewLog: (item) => {
              this.viewAdjustLog(item);
            }
          }
        })
      },
      viewAdjustLog(row) {
        this.$gjCreate(AppStrategyAdjustLogModal, {
          props: {
            item: row,
          }
        });
      },
          // 移除，二次确认
    deleteEvent(row) {
      deleteStrategy(this, row);
      // const modal = this.$gjCreate('gj-info-modal', {
      //   props: {
      //     title: '移除确认',
      //     content: `确定要移除分时策略吗？请谨慎操作！`
      //   },
      //   on: {
      //     cancel: () => modal.$gjDestroy(),
      //     confirm: () => {
      //       modal.confirmLoading = true;
      //        getResumeConditionInfo(row.objectId, row, (res) => {
      //           modal.confirmLoading = false
      //           if (res === 'success') {
      //             this.$gjMessage.success('移除成功');
      //             this.$gjResetPage();
      //             modal.$gjDestroy();
      //           }else {
      //             this.$gjMessage.success('移除失败，请稍后重试');
      //           }
               
      //         })
      //     }
      //   }
      // });

    },
    }
  }
</script>

<style scoped lang="scss">
  .gj-modal--custom {
    /deep/.el-dialog {
      width: 1400px !important;
    }
  }
  .bid-refresh {
    color: #0046f0;
    cursor: pointer;
  }
  /deep/.vxe-cell .is-align-middle{
    align-items: flex-start;
  }
</style>
